import { axios } from '@/utils/request'
import ipConfig from '../../config/ip.config'
export const api = {
  orderCusSearch: ipConfig.api_mdt + '/api/Order/CusSearch', // 订单查询
  GetARByCusID: ipConfig.api_mdt + '/api/ContractBasic/GetARByCusID', // 发票列表
  GetConBaseByCusID: ipConfig.api_mdt + '/api/ContractBasic/GetConBaseByCusID', // 合同列表
  DCInbound: ipConfig.api_storage + '/V1/EQuery/DCInbound', // dc入库查询
  DCStock: ipConfig.api_storage + '/V1/EQuery/DCStock', // dc库存查询
  DCOutbound: ipConfig.api_storage + '/V1/EQuery/DCOutbound', // dc出库查询
  CFSInbound: ipConfig.api_storage + '/V1/EQuery/CFSInbound', // cfs入库查询
  CFSPhoto: ipConfig.api_storage + '/V1/EQuery/CFSPhoto', // cfs照片查询
  DCStockExport: ipConfig.api_storage + '/files/DCStockExport', // 库存导出
  getExportPortList: ipConfig.api_basic + '/api-basic/v1/IApiExportPortController/getListByFuzzyName' // 海运起始港目的港
}

export function orderCusSearch (params) {
  return axios({
    url: api.orderCusSearch,
    method: 'get',
    params
  })
}
export function GetARByCusID (params) {
  return axios({
    url: api.GetARByCusID,
    method: 'get',
    params
  })
}
export function GetConBaseByCusID (params) {
  return axios({
    url: api.GetConBaseByCusID,
    method: 'get',
    params
  })
}
export function getExportPortList (params) {
  return axios({
    url: api.getExportPortList,
    method: 'post',
    data: params,
    params
  })
}
export function DCInbound (data) {
  return axios({
    url: api.DCInbound,
    method: 'post',
    data
  })
}
export function DCStock (data) {
  return axios({
    url: api.DCStock,
    method: 'post',
    data
  })
}
export function DCOutbound (data) {
  return axios({
    url: api.DCOutbound,
    method: 'post',
    data
  })
}
export function CFSInbound (data) {
  return axios({
    url: api.CFSInbound,
    method: 'post',
    data
  })
}
export function CFSPhoto (data) {
  return axios({
    url: api.CFSPhoto,
    method: 'post',
    data
  })
}
export function DCStockExport (data) {
  return axios({
    url: api.DCStockExport,
    method: 'post',
    data,
    responseType: 'blob'
  })
}
